module.exports = __webpack_public_path__ + "img/four.00a61fea.png";